import { createSlice } from '@reduxjs/toolkit';
import { pushDynamicTab } from '../utils/dynamicTabs';

// 🔹 Define the current version of the slice
const SLICE_VERSION = '1.2';

// 🔹 Exported initial state for use in version-based merging
export const initialState = {
  _version: SLICE_VERSION,
  defaultTabs: [
    { id: 'shipment-notifications', name: 'Shipment Alerts' },
    { id: 'invoice-notifications', name: 'Invoice Alerts' },
  ],
  dynamicTabs: [],
  activeTab: 0,
};

/// 🔹 Create the NotificationCenter slice
const NotificationCenterSlice = createSlice({
    name: 'NotificationCenter',
    initialState,
    reducers: {
      addTab: (state, action) => {
        let tabDetails;
  
        if (action.payload) {
          tabDetails = action.payload;
        } else {
          const dynamicId =
            window.crypto?.randomUUID?.() ||
            `${Date.now()}-${Math.random().toString(36).slice(2, 15)}-${state.dynamicTabs.length}`;
          tabDetails = {
            id: `dyn-${dynamicId}`,
            name: `New Notification ${state.dynamicTabs.length + 1}`,
            isDynamic: true,
            createdAt: Date.now(),
          };
        }
  
        pushDynamicTab(state, tabDetails, state.defaultTabs.length);
      },
  
      removeTab: (state, action) => {
        const { tabIndex } = action.payload;
        if (tabIndex < state.defaultTabs.length) return;
  
        const dynamicIndex = tabIndex - state.defaultTabs.length;
        state.dynamicTabs.splice(dynamicIndex, 1);
  
        state.activeTab = Math.min(
          state.activeTab,
          state.defaultTabs.length + state.dynamicTabs.length - 1
        );
      },
  
      setActiveTab: (state, action) => {
        const { index } = action.payload;
        if (index >= 0 && index < state.defaultTabs.length + state.dynamicTabs.length) {
          state.activeTab = index;
        }
      },
  
      resetTabs: (state) => {
        state.dynamicTabs = [];
        state.activeTab = 0;
      },
    },
  });
  
  // 🔹 Export actions and reducer
  export const { addTab, removeTab, setActiveTab, resetTabs } = NotificationCenterSlice.actions;
  export default NotificationCenterSlice.reducer;